import React from 'react';
import { Image } from '@fupa/fupa-uikit';
import { desktopContentWidth } from 'app/styles/media';
import { ImageEntity } from '@fupa/fupa-uikit';
import { ImageContainer } from 'app/components/topNewsModule/mainNews/mainNewsStyles';
export default function MainNewsImage(_ref) {
  let {
    image
  } = _ref;
  return /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-component": "MainNewsImage",
    "data-sentry-source-file": "MainNewsImage.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.News,
    actualWidthFactor: 1,
    sizesHint: "(min-width: ".concat(desktopContentWidth, "px) ").concat(desktopContentWidth, "px, 100vw"),
    ratio: "16:9",
    src: image,
    eager: true,
    fetchPriority: 'high',
    "data-sentry-element": "Image",
    "data-sentry-source-file": "MainNewsImage.tsx"
  }));
}